/**
 * RegulatoryDisclaimers - Legal and regulatory information for prosumer calculations.
 *
 * Displays collapsible regulatory notices covering:
 * - Deposit tax-neutral status (Art. 2 sec. 1 pt. 9 PIT)
 * - 1.23× correction coefficient (from February 2025)
 * - RCE price volatility (PSE market prices)
 * - Indicative nature of tariff rates
 */

import { Accordion, Text, Stack } from '@mantine/core';

export function RegulatoryDisclaimers() {
  return (
    <Accordion variant="contained" radius="sm">
      <Accordion.Item value="disclaimers">
        <Accordion.Control>
          <Text size="sm" fw={500} c="dimmed">Zastrzeżenia prawne i regulacyjne</Text>
        </Accordion.Control>
        <Accordion.Panel>
          <Stack gap="xs">
            <Text size="xs" c="dimmed">
              Rozliczenie depozytu prosumenta jest neutralne podatkowo (art. 2 ust. 1 pkt 9 ustawy o PIT).
              Środki z depozytu nie stanowią przychodu w rozumieniu przepisów podatkowych.
              W razie wątpliwości skonsultuj się z doradcą podatkowym.
            </Text>
            <Text size="xs" c="dimmed">
              Współczynnik korekcyjny 1,23× obowiązuje od lutego 2025 (zmiana regulacji URE).
              Wcześniejsze depozyty mogły być naliczane bez tego współczynnika.
            </Text>
            <Text size="xs" c="dimmed">
              Ceny RCE są cenami giełdowymi (PSE) i mogą się zmieniać z dnia na dzień.
              Wartości używane w kalkulatorze są szacunkowe i oparte na danych historycznych.
            </Text>
            <Text size="xs" c="dimmed">
              Stawki taryf są orientacyjne — rzeczywiste zależą od umowy z OSD (operatorem
              systemu dystrybucyjnego) oraz aktualnych taryf zatwierdzonych przez URE.
            </Text>
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
